import type { Note } from '../domain/note'
import type { NoteAsset } from '../assets/assetTypes'
import { DEFAULT_BROWSE_PRESENTATION } from '../search/browsePresentation'
import { SearchResultCard } from './SearchResultCard'

const noAction = () => {}

/**
 * The production compact card, without editing, selection or navigation affordances. `terms` are marked like search matches, and
 * the card shows the part of the note around the first one; `expanded` lifts the compact card's limit on how much of the note it shows.
 */
export function BrowseNotePreview({ note, assets = [], remoteAssetUrls, terms = [], expanded = false }: {
  note: Note; assets?: NoteAsset[]; remoteAssetUrls?: ReadonlyMap<string, string>; terms?: string[]; expanded?: boolean
}) {
  return <div className={expanded ? 'browse-note-preview browse-note-preview--expanded search-results search-results--compact' : 'browse-note-preview search-results search-results--compact'}>
    <SearchResultCard note={note} previewOnly copied={false} layout="compact"
      presentation={expanded ? { ...DEFAULT_BROWSE_PRESENTATION.layouts.compact, maxTextChars: 0 } : DEFAULT_BROWSE_PRESENTATION.layouts.compact}
      assets={assets.filter(asset => note.assetIds.includes(asset.id))} expectedCount={note.assetIds.length}
      remoteAssetUrls={remoteAssetUrls}
      result={{ id: note.id, score: 0, title: note.manualTitle || note.derivedTitle, snippet: note.body,
        matchTerms: terms, status: note.status, contentType: note.contentType, modifiedAt: note.modifiedAt, nextReminderAt: null }}
      onCopy={noAction} onBump={noAction} onOpen={noAction} onStatusChange={noAction} />
  </div>
}
